import { useEffect } from "react";

export const SITE_NAME = "FABRIPAN, Directo de fábrica a su panadería";
export const DEFAULT_DESCRIPTION = "FABRIPAN, directo de fábrica a su panadería. Fabricante de bandejas, armarios de transporte, carros bandejeros, moldes y equipamiento profesional para panaderías y pastelerías. Fabricación bajo pedido y envío a toda España.";
export const DEFAULT_KEYWORDS = "fabripan, equipamiento panadería, bandejas panadería, bandejas aluminio, armarios transporte panadería, carros bandejeros, moldes panadería, maquinaria panadería, suministros panadería, fabricante panadería, directo de fábrica";

function setMeta(name, content, attr = "name") {
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!content) { if (el) el.remove(); return; }
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export const buildTitle = (title) => {
  if (!title) return SITE_NAME;
  const t = title.replace(/\s*[|—-]\s*FABRIPAN.*$/i, "").trim();
  return t ? `${t} | ${SITE_NAME}` : SITE_NAME;
};

/** SEO: title, description, keywords, OG/Twitter, canonical, robots, JSON-LD */
export default function Seo({ title, description, keywords, image, jsonLd, noindex, type = "website" }) {
  useEffect(() => {
    const fullTitle = buildTitle(title);
    const desc = (description || DEFAULT_DESCRIPTION).slice(0, 160);
    const kw = [keywords, DEFAULT_KEYWORDS].filter(Boolean).join(", ");
    const canonical = `${window.location.origin}${window.location.pathname}`.replace(/\/+$/, "") || window.location.origin;
    const img = image ? (image.startsWith("http") ? image : `${window.location.origin}${image}`) : `${window.location.origin}/logo.svg`;

    document.title = fullTitle;
    document.documentElement.lang = "es";
    setMeta("description", desc);
    setMeta("keywords", kw);
    setMeta("author", "FABRIPAN");
    setMeta("robots", noindex ? "noindex,nofollow" : "index,follow,max-image-preview:large,max-snippet:-1");
    setMeta("googlebot", noindex ? "noindex,nofollow" : "index,follow");
    setMeta("og:site_name", SITE_NAME, "property");
    setMeta("og:locale", "es_ES", "property");
    setMeta("og:type", type, "property");
    setMeta("og:title", fullTitle, "property");
    setMeta("og:description", desc, "property");
    setMeta("og:url", canonical, "property");
    setMeta("og:image", img, "property");
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", fullTitle);
    setMeta("twitter:description", desc);
    setMeta("twitter:image", img);
    setLink("canonical", canonical);

    let script = document.getElementById("jsonld-seo");
    if (jsonLd) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = "jsonld-seo";
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) {
      script.remove();
    }
    return () => {
      const s = document.getElementById("jsonld-seo");
      if (s) s.remove();
    };
  }, [title, description, keywords, image, jsonLd, noindex, type]);

  return null;
}
